export const readFileHexHeader = async (
  file: File,
  byteLength: number,
  withSpace?: false,
): Promise<string> => {
  const buffer = await file.slice(0, byteLength).arrayBuffer();
  const bytes = new Uint8Array(buffer);
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join(withSpace ? ' ' : '');
};

const decoder = new TextDecoder('ascii');

export const parseFirmwareHeader = async (
  file: File,
): Promise<{ firmwareVersion: string; hardwareVersion: string }> => {
  const buffer = await file.slice(2, 18).arrayBuffer();
  const bytes = new Uint8Array(buffer);
  const decode = (arr: Uint8Array) =>
    decoder.decode(arr).replace(/\0/g, '').trim();
  return {
    firmwareVersion: decode(bytes.slice(0, 8)),
    hardwareVersion: decode(bytes.slice(8, 16)),
  };
};
